import { render, staticRenderFns } from "./ClientProfileReversal.vue?vue&type=template&id=58aeb5b7"
import script from "./ClientProfileReversal.vue?vue&type=script&lang=js"
export * from "./ClientProfileReversal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports